import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-bell" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-warning navbar-badge" }, "15", -1)
const _hoisted_3 = { class: "dropdown-item dropdown-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_5 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope mr-2" }, null, -1)
const _hoisted_7 = { class: "float-right text-muted text-sm" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_9 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users mr-2" }, null, -1)
const _hoisted_11 = { class: "float-right text-muted text-sm" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_13 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file mr-2" }, null, -1)
const _hoisted_15 = { class: "float-right text-muted text-sm" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_17 = {
  class: "dropdown-item dropdown-footer",
  href: "#"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_dropdown = _resolveComponent("app-dropdown")!

  return (_openBlock(), _createBlock(_component_app_dropdown, { size: "lg" }, {
    "dropdown-button": _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    "dropdown-menu": _withCtx(() => [
      _createElementVNode("span", _hoisted_3, "15 " + _toDisplayString(_ctx.$t('labels.notifications')), 1),
      _hoisted_4,
      _createElementVNode("a", _hoisted_5, [
        _hoisted_6,
        _createTextVNode(" 4 " + _toDisplayString(_ctx.$t('labels.newMessages')) + " ", 1),
        _createElementVNode("span", _hoisted_7, "3 " + _toDisplayString(_ctx.$t('labels.mins')), 1)
      ]),
      _hoisted_8,
      _createElementVNode("a", _hoisted_9, [
        _hoisted_10,
        _createTextVNode(" 8 " + _toDisplayString(_ctx.$t('labels.friendRequests')) + " ", 1),
        _createElementVNode("span", _hoisted_11, "12 " + _toDisplayString(_ctx.$t('labels.hours')), 1)
      ]),
      _hoisted_12,
      _createElementVNode("a", _hoisted_13, [
        _hoisted_14,
        _createTextVNode(" 3 " + _toDisplayString(_ctx.$t('labels.newReports')) + " ", 1),
        _createElementVNode("span", _hoisted_15, "2 " + _toDisplayString(_ctx.$t('labels.days')), 1)
      ]),
      _hoisted_16,
      _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.$t('labels.seeAllNotification')), 1)
    ]),
    _: 1
  }))
}